var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStopwatchHalf = function SvgStopwatchHalf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.334 26.25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#43321e",
    d: "M11.168 26.25A11.158 11.158 0 0 1 2.655 7.886a.613.613 0 0 0-.034-.829L1.79 6.22a.61.61 0 0 0-.433-.18.61.61 0 0 0-.436.187l-.28.29a.372.372 0 0 1-.523-.529L2.08 4.026a.372.372 0 0 1 .529.523l-.289.28a.613.613 0 0 0-.007.874l.834.834a.61.61 0 0 0 .831.033 11 11 0 0 1 6.264-2.6.613.613 0 0 0 .563-.611v-2.01a.613.613 0 0 0-.613-.613h-.981a.368.368 0 0 1 0-.736h3.924a.368.368 0 0 1 0 .736h-.981a.613.613 0 0 0-.613.613V3.36a.613.613 0 0 0 .563.611 11.158 11.158 0 0 1-.924 22.278Zm-.006-21.589a10.422 10.422 0 1 0 10.422 10.422A10.434 10.434 0 0 0 11.162 4.661",
    "data-name": "Path 302"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#43321e",
    d: "M11.168 15.117v-9.2a9.2 9.2 0 0 1 9.164 8.44l.033.757Zm-9.2 0 .033-.76a9.2 9.2 0 0 1 9.167-8.44v9.2Z",
    "data-name": "Union 3"
  })));
};
export default SvgStopwatchHalf;